import { configureStore } from "@reduxjs/toolkit";
import userInterfaceSlice from "../Slices/userInterfaceSlice";
import settingsSlice from "../Slices/settingsSlice";
import assetsSlice from "../Slices/assetsSlice";
import soundsSlice from "../Slices/soundsSlice";
import animationsSlice from "../Slices/animationsSlice";
import loadingProgressReducer from "../Slices/loadingProgressSlice";
import freeRoundsSlice from "../Slices/freeRoundsSlice";
import replaySlice from "../Slices/replaySlice";

// Universal slices (provider-agnostic)
import gameSettingsSlice from "../Slices/gameSettingsSlice";
import spinSlice from "../Slices/spinSlice";
import featureGameSettingsSlice from "../Slices/featureGameSettingsSlice";
import potCollectionSlice from "../Slices/potCollectionSlice";
import freeSpinsSlice from "../Slices/freeSpinsSlice";
import holdAndWinSlice from "../Slices/holdAndWinSlice";
import { moneyTraceMiddleware } from "../../utils/moneyTrace";

const store = configureStore({
  reducer: {
    // Shared slices
    userInterface: userInterfaceSlice,
    settings: settingsSlice,
    animations: animationsSlice,
    sound: soundsSlice,
    assets: assetsSlice,
    loadingProgress: loadingProgressReducer,
    freeRounds: freeRoundsSlice,
    replay: replaySlice,

    // Universal game slices (work with any RGS provider)
    game: gameSettingsSlice,
    spin: spinSlice,
    featureGame: featureGameSettingsSlice,
    potCollection: potCollectionSlice,
    freeSpins: freeSpinsSlice,
    // Cleopatra's Fire Hold & Win — standalone, see holdAndWinSlice.
    holdAndWin: holdAndWinSlice,
  },
  // The defaults stay exactly as they were — thunk first, so our middleware
  // only ever sees plain actions. See utils/moneyTrace; inert unless
  // DEV_TOOLS.MONEY_DIAGNOSTICS is on.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(moneyTraceMiddleware),
});

export default store;
